module.exports = __webpack_public_path__ + "static/media/law.478bbf35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/SVG/law.svg
// module id = 157
// module chunks = 0